import $api from "@/zapi-frontend/shared/api/axios";
import { TAccessMode } from "./schemas";

export async function sendInvite({
  orgId,
  email,
  role,
  accessMode,
  firstName,
  lastName
}: {
  orgId: string;
  email: string;
  role: string;
  accessMode: TAccessMode;
  firstName: string;
  lastName: string;
}) {
  const response = await $api.get(`/auth/generate-invite`, {
    params: {
      orgId,
      email,
      role,
      accessMode,
      firstName,
      lastName
    }
  });

  return response.data;
}
